import React from 'react';
import './custom.css'

const Mani = () => {
    return (
        <section id='green'>
            <div className='container'>
                <div className='text-center'>
                    <h1 data-aos="flip-up" className='mani_header'>$M​ANI</h1>
                    <p className='mani_span'>Me​et MANI green token</p>
                </div>
                <div data-aos="fade-up" data-aos-duration="2000" className='mani_para d-none d-md-block' style={{ fontSize: '16px' }}>
                    <p >As a start, members are rewarded for verifying electric public transit, the most carbon efficient mode of travel.
                        $Mani is recorded on the blockchain on confirmation of blocks. Early miners mine more to incentivise early action.  It is a utility token adopting ERC-20  guidelines.  It shall be issued on a layer 2 blockchain. As and when required, it may be moved to an efficient blockchain. The utility tokens are fungible and interoperable with each other.
                    </p>
                </div>
                <div className='mt-3 d-block d-md-none' style={{ textAlign: 'center' }}>
                    <p className='minig_text' data-aos="fade-up" data-aos-duration="2000" style={{ color: 'black' }}>As a start, members are rewarded for verifying electric public transit, the most carbon efficient mode of travel.
                        $Mani is recorded on the blockchain on confirmation of blocks. Early miners mine more to incentivise early action.  It is a utility token adopting ERC-20  guidelines.  It shall be issued on a layer 2 blockchain. As and when required, it may be moved to an efficient blockchain. The utility tokens are fungible and interoperable with each other.
                    </p>
                </div>
                <div className='text-center'>
                    <h1 data-aos="fade-up" data-aos-duration="2000" className='earn_manimani'>Earn $MANI Tokens for green actions</h1>
                </div>
                <div data-aos="zoom-in-up" className='mt-5'>
                    <div className='d-flex justify-content-center mt-5'>
                        <div className='row g-5'>
                            <div className='col-md-4 d-flex justify-content-center lastImgg'>
                                <img src="/img/Mine icon 1.png" alt="" />
                            </div>
                            <div className='col-md-4 d-flex justify-content-center lastImgg'>
                                <img src="/img/Mine icon 2.png" alt="" />
                            </div>
                            <div className='col-md-4 d-flex justify-content-center lastImgg '>
                                <img src="/img/Mine icon 3.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Mani;